export { default } from './DeviceGalleryPage';
export { formatDeviceGalleryMeta } from './utils/metaTags.utils';
